import React, { useState, useEffect } from 'react';
import { Button } from '@mui/material';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/scss";
import './styles.sass';

const Selector = ({ categories, selectedCategory, setSelectedCategory, origin }) => {
    const [data, setData] = useState([]);
    const allRecipes = [`${origin}`];

    const handleClick = (item) => {
        if (item !== origin)
            setSelectedCategory(item);
        else
            setSelectedCategory('');
    }

    const classPick = (item) => {
        if (selectedCategory === item || (selectedCategory === '' && item === origin))
            return 'button selected';
        return 'button unselected';
    }

    useEffect(() => {
        setData(categories);
    }, [categories]);

    return (
        <div className="selector-container">
            <Swiper
                freeMode={true}
                spaceBetween={15}
                style={{ width: '100%' }}
            >
                {allRecipes.concat(data).map((item, index) => {
                    return (
                        <SwiperSlide key={index}>
                            <Button
                                key={index}
                                disableTouchRipple
                                className={classPick(item)}
                                onClick={() => handleClick(item)}
                            >
                                {item}
                            </Button>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    )
}

export default Selector;